import { useEffect, useState } from 'react';
import api from '../../utils/axios';

const TTL_MS = 120000;
const cache = new Map();

const params = ({ cuit, desde, hasta, casoId, episodioId }) => (
  casoId ? { caso_id: casoId, episodio_id: episodioId || undefined } : { cuit, desde, hasta }
);

// Una sola llamada a /padron-interno/analisis por fuente (CUIT + rango, caso o episodio), compartida por los gráficos.
export const useAnalisis = (fuente) => {
  const key = JSON.stringify(params(fuente));
  const habilitado = !!(fuente.cuit || fuente.casoId);
  const [state, setState] = useState({ data: null, loading: habilitado, error: null });

  useEffect(() => {
    if (!habilitado) return undefined;
    let vivo = true;
    const hit = cache.get(key);
    if (!hit || Date.now() - hit.t > TTL_MS) {
      const p = api.get('/padron-interno/analisis', { params: JSON.parse(key), timeout: 180000 }).then((r) => r.data);
      p.catch(() => cache.delete(key));
      cache.set(key, { t: Date.now(), p });
    }
    setState((s) => ({ ...s, loading: true, error: null }));
    cache.get(key).p
      .then((data) => vivo && setState({ data, loading: false, error: null }))
      .catch((e) => vivo && setState({ data: null, loading: false, error: e.response?.data?.detail || 'No se pudo cargar el análisis' }));
    return () => { vivo = false; };
  }, [key, habilitado]);

  return state;
};

export const formatoMonto = (v) => `$${Number(v || 0).toLocaleString('es-AR', { maximumFractionDigits: 0 })}`;
